module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A NessieLogo contains the Nessie project logo.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;NessieLogo/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/NessieLogo/README.md
// module id = 368
// module chunks = 0